<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 nav-top">
                        <div class="row">
                            <div class="col-2 xtl"><span class="nav-back wt" onclick="window.location.href='#/'"></span>
                            </div>
                            <div class="col-8 tfw-5 tf-18">Fast-Parity</div>
                            <div class="col-2 xtr mcpl" @click="readrule()">Rule</div>
                        </div>
                    </div>
                    <div class="col-12 gmxcfm">
                        <div class="row mt-2 tfwr pt-2">
                            <div class="col-6 xtl">
                                <div class="tf-16 mb-2 tfcdg">Period</div>
                                <div class="tfcdb tf-24 tfw-5 period" id="cpd">{{ userdetails.period }}</div>
                            </div>
                            <div class="col-6 xtr">
                                <div class="tf-16 mb-2 tfcdg">Count Down</div>
                                <div class="cd" id="demo" onclick="CRN30SP()">

                                </div>
                                <div id="cdx"></div>
                            </div>
                        </div>
                        <div class="row mr-0 mt-4 tf-18">
                            <div class="col-4 pa-0">
                                <div class="join green disabled" id="jcg" @click="join('Green')">
                                    <div class="tfw-6"><span class="rocket sm"></span></div>
                                    <div class="tfw-5">Join Green</div>
                                </div>
                                <div class="tflh-10 tf-14 tfcdg">1:2</div>
                            </div>
                            <div class="col-4 pa-0">
                                <div class="join violet disabled" id="jcv" @click="join('Violet')">
                                    <div class="tfw-6"><span class="rocket sm"></span></div>
                                    <div class="tfw-5">Join Violet</div>
                                </div>
                                <div class="tflh-10 tf-14 tfcdg">1:4.5</div>
                            </div>
                            <div class="col-4 pa-0">
                                <div class="join red disabled" id="jcr" @click="join('Red')">
                                    <div class="tfw-6"><span class="rocket sm"></span></div>
                                    <div class="tfw-5">Join Red</div>
                                </div>
                                <div class="tflh-10 tf-14 tfcdg">1:2</div>
                            </div>
                            <div class="col-12 pt-2">
                                <div class="row">
                                    <div class="col-12 adcon">
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn1" @click="join('1')">1</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn2" @click="join('2')">2</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn3" @click="join('3')">3</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn4" @click="join('4')">4</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn5" @click="join('5')">5</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn6" @click="join('6')">6</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn7" @click="join('7')">7</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn8" @click="join('8')">8</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn9" @click="join('9')">9</div>
                                        </div>
                                        <div class="wdt2">
                                            <div class="jnum fp disabled" id="jn0" @click="join('0')">0</div>
                                        </div>
                                    </div>
                                    <div class="col-12 tflh-10 tf-14 tfcdg">1:9</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="row" id="nfrm" style="display:none;">
                            <div class="col-12 pa-0 odbox bslidein">
                                <div :class="betclass('xsel')" id="nxsel">Join {{ betbox.title }}</div>
                                <div class="row bfard">
                                    <div class="col-6 xtl tfcdb tf-20 tffss"><span class="tf-28" id="u_bal">{{
                                        userdetails.balance
                                    }}</span>
                                    </div>
                                    <div class="col-6 pl-0 pr-1 xtr pt-1">
                                        <div class="rc-wal" onclick="window.location.href='#/recharge'">Recharge</div>
                                    </div>
                                </div>
                                <div class="row mr-0 pa-10">
                                    <div class="col-12 xtl">Contract Money</div>
                                    <div class="col-12 tf-16 xtl" id="factorlist">
                                        <div :class="betclass('cont-amt selected')" id="10" @click="selectmultiply(10)">
                                            10</div>
                                        <div :class="betclass('cont-amt')" id="100" @click="selectmultiply(100)">100
                                        </div>
                                        <div :class="betclass('cont-amt')" id="1000" @click="selectmultiply(1000)">1000
                                        </div>
                                        <div :class="betclass('cont-amt')" id="10000" @click="selectmultiply(10000)">
                                            10000</div>
                                    </div>
                                </div>
                                <div class="row mr-0 pa-10">
                                    <div class="col-12 xtl">
                                        <div class="silb mr-2">Number</div>
                                        <div class="row">
                                            <div class="col-5 xtl pr-0"><span class="xpan" id="xm5"
                                                    @click="minus(5)">-5</span><span class="xpan" id="xm"
                                                    @click="minus(1)">-1</span></div>
                                            <div class="col-2 xtc"><span class="xnum" id="xn">{{
                                                betbox.multiply
                                            }}</span>
                                            </div>
                                            <div class="col-5 xtr pl-0"><span class="xpan" id="xp"
                                                    @click="plus(1)">+1</span><span class="xpan" id="xp5"
                                                    @click="plus(5)">+5</span></div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-2 tf-16 xtl">Total contract money is <span id="tca">{{
                                        betbox.amount
                                    }}</span>
                                    </div>
                                </div>
                                <div class="row mr-0 mb-2">
                                    <div class="col-12 xtr">
                                        <div :class="betclass('btn-con newod')" id="nod" @click="confirmbet()">Confirm
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 betfbg" id="blackscreen" @click="closescreen()" style="display: none;"></div>
                    <div class="col-12 mt-2">
                        <div class="row tffm h264">
                            <div class="col-12 tfw-7 tabin active" id="rcdv">Record</div>
                            <div class="col-12">
                                <div class="row tf-16 mr-0" id="xrecd">
                                    <div class="col-8 mt-2 mb-2 pb-2 pl-0 xtl tf-18 tfcdb">Fast-Parity Record(s)</div>
                                    <div class="col-4 mt-2 mb-2 pb-2 pr-0 tf-14 xtr"><span class="mcpl tfcdg"
                                            onclick="window.location.href='#/record?server=FastParity'">more &gt;</span>
                                    </div>
                                    <div class="col-12">
                                        <div class="row record">


                                            <div class="rcd-pillar mb-2" v-for="row in resultrec" :key="row.id">
                                                <div :class="getcolor(row.clo)">
                                                    <div class="vil" v-show="row.res1 === 'violet'"></div>
                                                    <div class="tpr">{{ row.ans }}</div>
                                                </div>
                                                <div class="rcd-per">{{ row.period % 1000 }}</div>
                                            </div>

                                            <div class="rcd-pillar mb-2" id="upcp">
                                                <div class="per-rcd dn upn"><b>?</b></div>
                                                <div class="rcd-per">{{ userdetails.period % 1000 }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mr-0" id="capr"></div>
                            </div>
                        </div>
                        <div class="row mr-0" id="lfprd"></div>
                        <div class="row mt-2">
                            <div class="col-6 tfw-6 tffm tabin active" id="every" @click="everyoneorder()">Everyone's Order
                            </div>
                            <div class="col-6 tfw-6 tffm tabin" id="my" @click="myorder()">My Order</div>
                            <div class="col-12" id="myorder" style="display: none;">
                                <div class="row plr-10 pb-2">
                                    <div class="col-12 pb-3 pt-2 tf-14 dflx">
                                        <div class="wd-100 xtl">Period</div>
                                        <div class="wd-36">Select</div>
                                        <div class="wd-46">Point</div>
                                        <div class="wd-36">Result</div>
                                        <div class="wd-80 xtr">Amount</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" id="mywod"></div>
                                    <div class="col-12" id="myod">
                                        <div class="row plr-10">
                                            <div class="col-12 lih-32 pt-2 pb-2 dflx" v-for="rows in betrec" :key="rows.id"
                                                :rowsrec="rows">
                                                <div class="wd-100 xtl">{{ rows.period }}</div>
                                                <div class="wd-36"><span
                                                        :class="getcolor(rows.ans)">{{ short(rows.ans) }}</span></div>
                                                <div class="wd-46">{{ rows.amount }}</div>
                                                <div class="wd-36" v-html="getele(rows.number)">

                                                </div>
                                                <div class="wd-80 xtr"
                                                    v-html="betamount(rows.amount, rows.ans, rows.res, rows.color2)">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="m-order"
                                            onclick="window.location.href='#/orderrecord?server=FastParity'">more &gt;</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" id="everyoneorder">
                                <div class="row">
                                    <div class="col-4 tf-14 pt-2 xtl">Period</div>
                                    <div class="col-3 tf-14 pt-2">User</div>
                                    <div class="col-2 tf-14 pt-2">Select</div>
                                    <div class="col-3 tf-14 pt-2 xtr">Point</div>
                                </div>
                                <div class="row">
                                    <marquee direction="down" id="everyone" scrollamount="3">
                                        <div class="col-12" id="fseod">
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***529</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***122</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***426</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***158</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***333</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***895</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***962</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***125</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***194</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***840</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***740</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***504</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">500</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***837</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***368</div>
                                                <div class="col-2 "><span class="NS">8</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***077</div>
                                                <div class="col-2 "><span class="VS">V</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***633</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***820</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">500</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***866</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">30</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***848</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">30</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***177</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***904</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***530</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***174</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">3000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***233</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***228</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">4000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***946</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***314</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">60</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***881</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***142</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***658</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***124</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***612</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***224</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***099</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***217</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***015</div>
                                                <div class="col-2 "><span class="NS">5</span></div>
                                                <div class="col-3 xtr">30</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***021</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">40000</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***758</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">300</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***757</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***443</div>
                                                <div class="col-2 "><span class="VS">V</span></div>
                                                <div class="col-3 xtr">50</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***546</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***540</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***576</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***140</div>
                                                <div class="col-2 "><span class="VS">V</span></div>
                                                <div class="col-3 xtr">500</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***189</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">30</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***618</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***306</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***422</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">20000</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***586</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***040</div>
                                                <div class="col-2 "><span class="VS">V</span></div>
                                                <div class="col-3 xtr">5000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***278</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">30</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***016</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">40</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***281</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***703</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***277</div>
                                                <div class="col-2 "><span class="VS">V</span></div>
                                                <div class="col-3 xtr">500</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***427</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">20</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***377</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***619</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***116</div>
                                                <div class="col-2 "><span class="NS">7</span></div>
                                                <div class="col-3 xtr">50</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***094</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">500</div>
                                            </div>

                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***039</div>
                                                <div class="col-2 "><span class="RS">R</span></div>
                                                <div class="col-3 xtr">12000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{ userdetails.period }}</div>
                                                <div class="col-3 cgray">***414</div>
                                                <div class="col-2 "><span class="GS">G</span></div>
                                                <div class="col-3 xtr">50</div>
                                            </div>
                                        </div>
                                    </marquee>
                                </div>
                            </div>

                        </div>
                        <div class="row mr-0 mordm"></div>
                    </div>
                    <div class="col-12" id="suc-fail">
                        <div class="col-12 conod" @click="resclose()" id="rlink"  style="display:none">
                            <div class="row podfs fadein" id="smgid">
                                <div :class="getrcl(result.res)">{{ getr(result.res) }}</div>
                                <div class="col-12" v-if="result.res === 'success'"><img class="winxIMG" src="../assets/includes/images/win.png" width="320"></div>
                                <div class="col-12 pt-2 pb-2"><span :class="getcl(result.number)" >{{result.number}}</span></div>
                                <div class="col-12">
                                    <div class="row tfcdb tf-16 xtl">
                                        <div class="col-4 pb-1">Period</div>
                                        <div class="col-8 pb-1 xtr">{{result.period}}</div>
                                        <div class="col-4">Price</div>
                                        <div class="col-8 xtr">{{result.price}}</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="row tfcdb selwnlbx xtl">
                                        <div class="col-4 pl-1 pb-1">Select</div>
                                        <div class="col-8 pr-1 xtr pb-1"><span :class="resclass(result.ans)" >{{result.ans}}</span></div>
                                        <div class="col-4 pl-1 pb-1">Point</div>
                                        <div class="col-8 pr-1 xtr pb-1 tf-16">{{result.amount}}</div>
                                        <div class="col-4 pl-1 pb-1">Amount</div>
                                        <div class="col-8 pr-1 xtr pl-0 pb-1 tf-24 tfwr" v-html="betamount(result.amount, result.ans, result.res, result.color2)">
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mb-3">
                                    <div class="btn-main act">CLOSE</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 betfbg" id="bfbg" onclick="clsbfrm()"></div>
                    <div class="col-12" id="ucheck"></div>
                    <div class="col-12 bbg" id="xrule" style="display: none;">
                        <div class="col-12 botfrm bslidein" style="display: block;">
                            <div class="tf-20 mt-3 mb-3"><span class="grlm">FastParity Rule</span></div>
                            <div class="row mt-2 pb-2 tfcdb grh-60">
                                <div class="col-12 xtl tf-16">
                                    <div class="justify">30 seconds 1 issue,24 seconds to order,6 seconds to show the
                                        lottery result. It opens all day. The total number of trade is 2880 issues.
                                    </div>
                                    <div class="justify pt-2">If you spend 100 rupees to trade,after deducting 2 rupees
                                        service fee,your contract amount is 98 rupees:</div>
                                </div>
                                <div class="col-12 tfs-b tf-14 pt-2 justify">
                                    <ul class="pl-4">
                                        <li class="pt-1">JOIN GREEN:if the result shows 1,3,7,9,you will get (98*2) 196
                                            rupees;If the result shows 5,you will get (98*1.5) 147 rupees.</li>
                                        <li class="pt-1">JOIN RED:if the result shows 2,4,6,8,you will get (98*2) 196
                                            rupees;If the result shows 0,you will get (98*1.5) 147 rupees.</li>
                                        <li class="pt-1">JOIN VIOLET:if the result shows 0 or 5,you will get (98*4.5)
                                            441 rupees.</li>
                                    </ul>
                                </div>
                                <div class="col-12 tfs-b tf-14 xtc">
                                    <div class="row mr-0 tlh-36 tfwr">
                                        <div class="col-3 grth grbd-l grbd-b grbd-t">Select</div>
                                        <div class="col-6 grth grbd-l grbd-r grbd-b grbd-t">Result</div>
                                        <div class="col-3 grth grbd-r grbd-b grbd-t">Multiplier</div>
                                        <div class="col-3 xtc grbd-l grbd-b pt-3 pl-2">
                                            <g>Join Green</g>
                                        </div>
                                        <div class="col-9 grbd-l grbd-r grbd-b">
                                            <div class="row">
                                                <div class="col-8 grbd-b">1,3,7,9</div>
                                                <div class="col-4 grbd-b grbd-l">2</div>
                                                <div class="col-8">5</div>
                                                <div class="col-4 grbd-l">1.5</div>
                                            </div>
                                        </div>
                                        <div class="col-3 xtc grbd-l grbd-b pt-3 pl-2">
                                            <r>Join Red</r>
                                        </div>
                                        <div class="col-9 grbd-l grbd-r grbd-b">
                                            <div class="row">
                                                <div class="col-8 grbd-b">2,4,6,8</div>
                                                <div class="col-4 grbd-b grbd-l">2</div>
                                                <div class="col-8">0</div>
                                                <div class="col-4 grbd-l">1.5</div>
                                            </div>
                                        </div>
                                        <div class="col-3 xtc grbd-l grbd-b pl-2">
                                            <v>Join Violet</v>
                                        </div>
                                        <div class="col-6 grbd-r grbd-l grbd-b">0,5</div>
                                        <div class="col-3 grbd-r grbd-b">4.5</div>
                                        <div class="col-3 xtc grbd-l grbd-b pl-2">Number</div>
                                        <div class="col-6 grbd-r grbd-l grbd-b">n</div>
                                        <div class="col-3 grbd-r grbd-b">9</div>
                                    </div>
                                </div>
                                <div class="col-12 fixn">
                                    <div class="btn-con cls" @click="closerule()">I GOT IT</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer"></div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">

                </div>
                <div class="row" id="clink" style="display:none">
                    <div class="col-12 conod LR" @click="cpop()">
                        <div class="ssmg fadein">
                            <div class="tf-14 pb-2" id="message"> </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios";
export default {
    name: "WinView",
    props: ['rowsrec'],
    data() {
        return {
            isActive: false,
            userdetails: {
                username: null,
                balance: null,
                period: null,

            },
            betbox: {
                title: null,
                target: null,
                boxcolor: null,
                timeout: false,
                multiply: 1,
                factor: 10,
                amount: 10,
                page: 1,
                page1: 1,
                total: 1000,
                total1: null,

            },
            result:{
                period:null,
                price:null,
                number:null,
                ans:null,
                res:null,
                amount:null,
                color2:null,
            },
            resultrec: '',
            info: '',
            betrec: ''

        }

    },
    mounted: function () {
        this.fechresultrec();
        this.countdown();
        this.refreshcountdown = setInterval(this.countdown, 1000);

    },
    beforeUnmount: function () {
        console.log("unmount");
        clearInterval(this.refreshcountdown);

    },
    created: function () {
       
        // this.expand();
    },
    methods: {
    resclass(res){
        if(res=='green'){
            return 'GS selcol'
        }else if(res=='red'){
            return 'RS selcol'
        }else if(res=='violet'){
            return 'VS selcol'
        }else{
            return 'NS selcol'
        }
        
    },
    getcl(num){
        if(num%2==0){
            return 'RXL';
        }else{
            return 'GXL';
        }
    },
        pop(message) {
            document.getElementById("message").innerHTML = message;
            document.getElementById("clink").style.display = "";

        },
        resopen(){
            document.getElementById("rlink").style.display = "";
        },
        resclose(){
            document.getElementById("rlink").style.display = "none";
        },
         cpop() {
            document.getElementById("clink").style.display = "none";

        },
        fechresultrec() {
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=result&server=FastParity').then((res) => {
                this.resultrec = res.data;
                console.log(this.resultrec);
            }).catch((err) => {
                console.log(err);
            })
            this.userdetails.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=betrec&user=' + this.userdetails.username + '&server=FastParity').then((res) => {
                this.betrec = res.data;
                this.result.period=this.betrec[0].period;
                this.result.price=this.betrec[0].price;
                this.result.number=this.betrec[0].number;
                this.result.ans=this.betrec[0].ans;
                this.result.amount=this.betrec[0].amount;
                this.result.res=this.betrec[0].res;
                this.result.color2=this.betrec[0].color2;

                console.log(this.betrec);
            }).catch((err) => {
                console.log(err);
            })

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=info&user=' + this.userdetails.username + '&per=FastParity').then((res) => {
                this.info = res.data;
                this.betbox.total = this.info[1].total;
                this.betbox.total1 = this.info[3].total1;
                this.userdetails.balance = this.info[0].balance;
                this.userdetails.period = this.info[2].period;
                console.log(this.info);
            }).catch((err) => {
                console.log(err);
            })
        },
       getrcl(res){
        if(res=="success"){
            return 'col-12 wnls win';
        }else{
            return 'col-12 wnls loss';
        }
       },
       getr(res){
        if(res=="success"){
            return 'WIN';
        }else{
            return 'LOSS';
        }
       },
        betamount(x, y, z, a) {
            var amount;
            var f;
            if (z == "fail") {
                f = 98 / 100 * x;
                amount = "<r> -" + (f.toFixed(2)) + "</r>";
                return amount;
            } else if (z == 'success') {
                if (a == "violet") {
                    if (y == "green" || y == "red") {
                        f = 98 / 100 * x * 1.5;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                    } else if (y == "violet") {
                        f = 98 / 100 * x * 4.5;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                    } else {
                        f = 98 / 100 * x * 9;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                    }
                } else {
                    if (y == "green" || y == "red") {
                        f = 98 / 100 * x * 2;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                    } else if (y == "violet") {
                        f = 98 / 100 * x * 1.5;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                    } else {
                        f = 98 / 100 * x * 9;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                    }
                }

            } else {
                return "<span class='icon wait'></span>";
            }
        },
        readrule() {
            document.getElementById("xrule").style.display = "";
        },
        closerule() {
            document.getElementById("xrule").style.display = "none";
        },
        join(label) {
            console.log(label);
            if (this.betbox.timeout) {
                if (label == "Green") {
                    this.betbox.target = "green";
                    this.betbox.boxcolor = "green";
                } else if (label == "Red") {
                    this.betbox.target = "red";
                    this.betbox.boxcolor = "red";
                } else if (label == "Violet") {
                    this.betbox.target = "violet";
                    this.betbox.boxcolor = "violet";
                } else {
                    this.betbox.target = label;
                    this.betbox.boxcolor = "Violet";
                }
                this.betbox.title = label;
                document.getElementById("nfrm").style.display = "block";
                document.getElementById("blackscreen").style.display = "block";
                this.fechresultrec();
            }

        },
        closescreen() {
            document.getElementById("nfrm").style.display = "none";
            document.getElementById("blackscreen").style.display = "none";
        },
        betclass(name) {
            return name + ' ' + this.betbox.boxcolor;
        },

        closebetbox() {
           
            var listItems = document.getElementById('factorlist').childNodes;
            // Remove 'active' tag for all list items
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].classList.remove('active');
            }
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
            document.getElementById("10").className = "active";
            this.betbox.multiply = 1;
            this.betbox.factor = 10;
            this.betbox.amount = 10;
        },
        selectmultiply(multi) {
            var listItems = document.getElementById('factorlist').childNodes;
            // Remove 'active' tag for all list items
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].classList.remove('selected');
            }
            this.betbox.factor = multi;
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
            document.getElementById(multi).className = "cont-amt selected " + this.betbox.target;
        },
        plus(value) {
            this.betbox.multiply = this.betbox.multiply + value;
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
        },
        minus(value) {
            if (this.betbox.multiply > value) {
                this.betbox.multiply = this.betbox.multiply - value;
                this.betbox.amount = this.betbox.factor * this.betbox.multiply
            }

        },
        myorder() {
            document.getElementById("every").classList.remove("active");
            document.getElementById("my").classList.add("active");
            document.getElementById("myorder").style.display = "";
            document.getElementById("everyoneorder").style.display = "none";
        },
        everyoneorder() {
            document.getElementById("my").classList.remove("active");
            document.getElementById("every").classList.add("active");
            document.getElementById("myorder").style.display = "none";
            document.getElementById("everyoneorder").style.display = "";
        },
        countdown() {
            var countDownDate = Date.parse(new Date) / 1e3;
            //var now = new Date().getTime();
            var distance = 30 - countDownDate % 30;
            //alert(distance);
            var i = distance / 60,
                n = distance % 60;
            //o = n / 10,
            // s = n % 10;
            var minutes = Math.floor(i);
            var seconds = ('0' + Math.floor(n)).slice(-2);
            var sec1 = (seconds % 100 - seconds % 10) / 10;
            var sec2 = seconds % 10;
            document.getElementById("demo").innerHTML = "<span class='cdspn'>0</span><span class='cdspn' id='fsm'> " + Math.floor(minutes) + "</span>:<span class='cdspn' id='fs0'>" + sec1 + "</span><span class='cdspn' id='fs1'>" + sec2 + "</span>";
            if (7 < distance) {
                document.getElementById("jcr").classList.remove("disabled");
                document.getElementById("jcg").classList.remove("disabled");
                document.getElementById("jcv").classList.remove("disabled");
                document.getElementById("jn0").classList.remove("disabled");
                document.getElementById("jn1").classList.remove("disabled");
                document.getElementById("jn3").classList.remove("disabled");
                document.getElementById("jn4").classList.remove("disabled");
                document.getElementById("jn5").classList.remove("disabled");
                document.getElementById("jn6").classList.remove("disabled");
                document.getElementById("jn7").classList.remove("disabled");
                document.getElementById("jn8").classList.remove("disabled");
                document.getElementById("jn9").classList.remove("disabled");
                document.getElementById("jn2").classList.remove("disabled");
                this.betbox.timeout = true;
            }
            if (7 > distance) {
                document.getElementById("jcr").classList.add("disabled");
                document.getElementById("jcg").classList.add("disabled");
                document.getElementById("jcv").classList.add("disabled");
                document.getElementById("jn0").classList.add("disabled");
                document.getElementById("jn1").classList.add("disabled");
                document.getElementById("jn2").classList.add("disabled");
                document.getElementById("jn3").classList.add("disabled");
                document.getElementById("jn4").classList.add("disabled");
                document.getElementById("jn5").classList.add("disabled");
                document.getElementById("jn6").classList.add("disabled");
                document.getElementById("jn7").classList.add("disabled");
                document.getElementById("jn8").classList.add("disabled");
                document.getElementById("jn9").classList.add("disabled");
                document.getElementById("nfrm").style.display = "none";
                document.getElementById("everyone").stop();
                document.getElementById("blackscreen").style.display = "none";
                this.betbox.timeout = false;
            }
            if (30 == distance) {
                this.fechresultrec();
            }

            if (28 == distance) {
                this.fechresultrec();
               if(this.betrec[0].period==(this.userdetails.period-1)){
                this.resopen();
               }
            }
            if (29 == distance) {
                this.fechresultrec();
                document.getElementById("everyone").start();
                document.getElementById("everyone").start();
            }


        },
        toggle(idx) {
            if (document.getElementById(idx).style.display == "") {
                document.getElementById(idx).style.display = "none";
            } else {
                document.getElementById(idx).style.display = "";
            }
        },
        confirmbet() {
            document.getElementById("nfrm").style.display = "none";
            document.getElementById("blackscreen").style.display = "none";
            if (this.userdetails.balance >= this.betbox.amount) {
                var data = new FormData();
                data.append("username", this.userdetails.username);
                data.append("period", this.userdetails.period);
                data.append("amount", this.betbox.amount);
                data.append("ans", this.betbox.target);
                axios
                    .post(
                        "https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=bet&server=FastParity",
                        data
                    )
                    .then(res => {
                        console.log(res.data); 
                        alert("success");
                        this.closebetbox();
                        this.fechresultrec();
                       
                    })
                    .catch(err => {
                        console.log("Error", err);
                    });
                this.fechresultrec();
            } else {
                this.pop("Low Balance!");
            }

        },
        load() {
            this.fechresultrec();
        },
        getcolor(stat) {
            if (stat == "red") {
                return 'RS';
            } else if (stat == "green") {
                return 'GS';
            } else if (stat == "violet") {
                return 'VS';
            } else {
                return 'NS';
            }
        },
        getele(ele) {
            if (ele % 2 == 1) {
                if (ele == 5) {
                    return "<div class='GS'><div class='vil'></div><div class='tpr'>" + ele + "</div></div>"
                } else {
                    return "<div class='GS'><div class=''></div><div class='tpr'>" + ele + "</div></div>"
                }

            } else if (ele % 2 == 0) {
                if (ele == 0) {
                    return "<div class='RS'><div class='vil'></div><div class='tpr'>" + ele + "</div></div>"
                } else {
                    return "<div class='RS'><div class=''></div><div class='tpr'>" + ele + "</div></div>"
                }
            } else {
                return "<div class='' style='margin-left: 25%;'><span class='icon wait'></span></div>"
            }
        },
        short(stat) {
            if (stat == "red") {
                return 'R';
            } else if (stat == "green") {
                return 'G';
            } else if (stat == "violet") {
                return 'V';
            } else {
                return stat;
            }
        }



    }
}

</script>